import styled from 'styled-components';

export const Popup = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;

  .modal-content {
    background-color: #ffffff;

    font-family: 'Montserrat';

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    width: 500px;
    height: 650px;

    .webinar {
      display: flex;
      align-items: center;
      justify-content: center;

      margin-top: 28px;

      width: 176px;
      height: 32px;

      text-align: center;

      font-weight: 700;
      font-size: 16px;
      color: rgba(248, 130, 11, 0.75);

      background: rgba(255, 191, 45, 0.1);

      border: 1px solid #ffbf2d;
      border-radius: 5px;
    }
    .subtitle {
      text-align: center;
      font-weight: 400;
      line-height: 150%;
      color: #545c68;

      margin-bottom: 20px;
    }

    .date {
      line-height: 150%;
      text-align: center;
      font-weight: 700;
      color: #545c68;
      margin-bottom: 20px;
    }

    .subscribe {
      font-family: 'Montserrat';

      width: 324px;
      height: 60px;

      margin-bottom: 30px;

      font-weight: 700;
      font-size: 19.2px;
      line-height: 58px;

      text-align: center;

      color: #ffffff;

      border: none;

      background: #2253f5;
      border-radius: 5px;

      cursor: pointer;

      &:hover {
        transition: transform 0.2s;
        transform: scale(1.05);
      }
    }
  }
`;
